<template>
  <div>
    <DatePicker
      class="PwDatePicker"
      width="100%"
      lang="es"
      v-model="computedValue"
      :format="format"
      ref="dateInput"
      :disabled="readonly"
      :open.sync="open"
      :disabled-date="notBefore"
      :type="mode"
      v-bind="$attrs"
      :append-to-body="false"
      @input="() => (open = false)"
    />
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/es';
import 'vue2-datepicker/index.css';
import moment from 'moment';

export default {
  name: 'Datepicker',
  props: {
    value: [Date, String],
    mode: {
      type: String,
      default: '',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    min: [Date, String],
    max: [Date, String],
    required: Boolean,
  },
  components: {
    DatePicker,
  },
  mounted() {
    this.changeRequired();
    if (typeof this.value === 'string') {
      this.date = moment(this.value).toDate();
    } else {
      this.date = this.value;
    }
  },
  data() {
    return {
      date: null,
      open: false,
    };
  },
  methods: {
    changeRequired() {
      if (this.$parent.changeRequired) {
        this.$parent.changeRequired(this.required);
      }
    },
    notBefore(date) {
      if (this.min) {
        const beforeDate = moment(this.min).toDate();
        if (date < beforeDate) {
          return true;
        }
      }

      if (this.max) {
        const afterDate = moment(this.max).toDate();
        if (date > afterDate) {
          return true;
        }
      }

      return false;
    },
    notAfter(date) {
      if (!this.max) {
        return false;
      }
      const afterDate = moment(this.max).toDate();
      return date > afterDate;
    },
  },
  computed: {
    format() {
      if (this.mode === 'month') {
        return 'MM-YYYY';
      }
      if (this.mode === 'year') {
        return 'YYYY';
      }
      return 'DD/MM/YYYY';
    },
    lang() {
      return 'es';
    },

    computedValue: {
      get() {
        return this.date;
      },
      set(val) {
        this.$emit('input', val);
        this.date = val;
      },
    },
  },
  watch: {
    min(val) {
      if (moment(val).isAfter(this.value)) {
        this.value = null;
      }
    },
    value(val) {
      if (typeof val === 'string') {
        this.date = moment(val).toDate();
      } else {
        this.date = val;
      }
    },
    required() {
      this.changeRequired();
    },
  },
};
</script>

<style lang="scss">
.PwDatePicker {
  width: 100%;
  height: 32px;
}
.mx-input-wrapper {
  .mx-input {
    font-family: 'Nunito Sans', sans-serif;
    border-radius: 3px;
    height: 32px;
    padding: 1px 0px 1px 8px;
    font-size: 16px;
    border: 1px solid #bdc6cc;
    color: #333;
    &::placeholder {
      color: #bdc6cc !important;
      text-transform: none;
    }
    &:disabled {
      background-color: #e9ecef;
      opacity: 1;
    }
  }
}

.mx-datepicker.disabled {
  opacity: 1;
}
</style>
